import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import NavBar from '../components/NavBar';

const FamilyInviteAccept = ({ user, onLogout }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/family-invite/${token}`);
        setInvite(res.data);
      } catch { setInvite({ valid: false, reason: 'not_found' }); }
      finally { setLoading(false); }
    })();
  }, [token]);

  const accept = async () => {
    setAccepting(true);
    try {
      const res = await axios.post(`${API}/family-invite/${token}/accept`);
      toast.success(`You're now linked to ${res.data.client_name}!`);
      navigate('/family/dashboard');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Failed to accept invite');
      setAccepting(false);
    }
  };

  if (loading) return <div className="loading-screen">Checking invite…</div>;

  return (
    <div className="dashboard-container">
      {user && <NavBar onLogout={onLogout} />}
      <div className="payment-result-wrapper" data-testid="family-invite-page">
        <div className="payment-result-card">
          {!invite?.valid && (
            <>
              <div className="payment-icon" style={{ background: '#dc2626' }}><i className="fa-solid fa-xmark" /></div>
              <h1>Invite {invite?.reason === 'expired' ? 'expired' : invite?.reason === 'already_used' ? 'already used' : 'not found'}</h1>
              <p>{invite?.reason === 'expired' ? 'This magic link has expired. Ask the caregiver to send you a new one.' : invite?.reason === 'already_used' ? "This invite has already been accepted." : "We couldn't find this invite. Double-check the link."}</p>
              <Link to="/dashboard" className="submit-button" style={{ width: 'auto', padding: '0.6rem 1.4rem', marginTop: '1rem' }}>Home</Link>
            </>
          )}

          {invite?.valid && !user && (
            <>
              <div className="payment-icon" style={{ background: '#2c5364' }}><i className="fa-solid fa-envelope-open" /></div>
              <h1>You've been invited!</h1>
              <p><strong>{invite.inviter_name || 'A caregiver'}</strong> invited you to follow <strong>{invite.client_name}</strong>'s daily care on CareGuard.</p>
              <p style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Sign in or create an account with <strong>{invite.invited_email}</strong> to accept.</p>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
                <Link to={`/auth?next=/family/invite/${token}`} className="submit-button" style={{ width: 'auto', padding: '0.75rem 1.5rem' }} data-testid="invite-signin-btn">
                  Sign in or Register <i className="fa-solid fa-arrow-right" />
                </Link>
              </div>
            </>
          )}

          {invite?.valid && user && (
            <>
              <div className="payment-icon" style={{ background: '#16a34a' }}><i className="fa-solid fa-user-plus" /></div>
              <h1>Follow {invite.client_name}?</h1>
              <p><strong>{invite.inviter_name || 'A caregiver'}</strong> invited you to see {invite.client_name}'s daily care logs. Accept to link your account.</p>
              <button className="submit-button" style={{ width: 'auto', padding: '0.75rem 1.5rem', marginTop: '1rem' }} onClick={accept} disabled={accepting} data-testid="invite-accept-btn">
                {accepting ? 'Linking…' : <><i className="fa-solid fa-check" /> Accept & Continue</>}
              </button>
              <p style={{ fontSize: '0.78rem', color: '#94a3b8', marginTop: '1rem' }}>You'll need a CareGuard Family subscription to view care logs (7-day free trial available).</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FamilyInviteAccept;
